<template>
  <div class="app-container">
    <el-container class="header_container">
      <el-header>
        <h2>应用管理-广点通</h2>
      </el-header>
      <el-main>
        <el-button size="mini" icon="el-icon-plus" type="primary" @click="showAddBox('add')">新增应用</el-button>
        <div class="main">
          <el-table
            v-loading="loading"
            :data="list"
            border
            fit
            highlight-current-row
            :row-class-name="tableRowClassName"
            size="mini"
            width="100%"
            height="72vh"
          >
            <el-table-column align="center" prop="name" label="应用名称" />
            <el-table-column align="center" prop="type_id" label="应用id" />
            <el-table-column align="center" prop="app_code" label="授权唯一标识" />
            <el-table-column align="center" prop="advertiser_name" label="投放媒体账号" />
            <el-table-column align="center" prop="plf_name" label="平台" />
            <el-table-column align="center" prop="operation" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="showAddBox('edit',scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteApp(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <el-pagination
              :page-size="meta.page_size"
              layout="total, prev, pager, next, jumper"
              :total="meta.total_number"
              @current-change="appCurrentChange"
            />
          </div>
        </div>
      </el-main>
    </el-container>

    <!-- 新增应用  -->
    <el-dialog
      v-loading="add.loading"
      :title="status === 'add'? '新增应用': '编辑应用' "
      :visible.sync="add.show"
      width="40%"
      :before-close="closeAddBox"
      center
    >
      <add
        v-if="add.show"
        :type="status"
        :data="add.data"
        @config="addSuccessCallback"
        @cancel="closeAddBox"
      />
    </el-dialog>
  </div>
</template>
<script>
// 请求用户列表的接口
import AppsResource from '@/api/apps';
const appsResource = new AppsResource();

import add from '@/views/system/app-manage/function/add';
export default {
  name: 'UserManage',
  components: { add },
  data() {
    return {
      loading: true,
      list: [],
      meta: {},
      status: 'add',
      options: [
        {
          value: '0',
          label: 'web',
        },
        {
          value: '1',
          label: 'ios正版',
        },
        {
          value: '2',
          label: 'ios越狱',
        },
        {
          value: '3',
          label: 'android',
        },
      ],
      query: {
        advertiser: 'gdt',
      },
      add: {
        show: false,
        data: {},
      },
    };
  },

  // 生命周期-创建
  created() {
    this.getAppList();
  },

  methods: {
    // 获取应用列表
    async getAppList() {
      this.loading = true;
      await appsResource
        .getAppList(this.query)
        .then((response) => {
          this.randerList(response.list);
          this.meta = response.page_info;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.loading = false;
        });
    },

    // 重构获取数据
    randerList(data) {
      data.forEach((item) => {
        item.plf_id = parseInt(item.plf_id);
        this.options.forEach((item1) => {
          if (item.plf_id === parseInt(item1.value)) {
            item.plf_name = item1.label;
          }
        });
      });
      this.list = data;
    },

    // 分页组件方法
    appCurrentChange(val) {
      this.query.page = val;
      this.getAppList();
    },

    // 显示新增框
    showAddBox(type, data) {
      this.add.show = true;
      this.add.data = data;
      this.status = type;
    },

    // 新增成功回调
    addSuccessCallback() {
      this.$message.success(`${this.status}成功`);
      this.add.show = false;
      this.getAppList();
    },

    // 关闭新增框
    closeAddBox(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.add.show = false;
          done();
        })
        .catch((_) => {});
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'success-row';
      }
      return '';
    },

    // 删除应用
    deleteApp(data) {
      const params = {
        source_ids: [data.id],
      };
      this.$confirm('是否删除应用' + data.name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          appsResource
            .deleteApp(params)
            .then((response) => {
              this.$message({
                message: `删除${data.name}应用成功`,
                type: 'success',
              });
            })
            .catch((error) => {
              console.log(error);
            })
            .then(() => {
              this.getAppList();
              this.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main {
  margin-top: 10px;
}
.permission_tag {
  margin: 2px;
}
.add_main {
  .add_input {
    width: 60%;
  }
}
.success-row {
  background-color: #f0f9eb !important;
}
.el-header {
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 10px;
}
.el-main {
  padding: 10px;
}
.header_container {
  background: #eef0f3;
  border-radius: 5px;
  .el-header {
    border-bottom: 1px solid #fff;
    h2 {
      margin: 0;
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
